import type { Prisma, PrismaClient } from '@prisma/client';

type Db = PrismaClient | Prisma.TransactionClient;

export interface AuditActor {
  companyId: number;
  userId?: number | null;
  ip?: string | null;
}

export interface AuditEntry {
  action: string;
  entity: string;
  entityId?: string | number | null;
  before?: unknown;
  after?: unknown;
}

/** Keys that must never reach the audit log. */
const SENSITIVE = /password|hash|secret|token|recovery|accountnumber/i;

export function scrub(value: unknown): Prisma.InputJsonValue | undefined {
  if (value === undefined || value === null) return undefined;
  return JSON.parse(
    JSON.stringify(value, (key, v) => {
      if (key && SENSITIVE.test(key)) return '[redacted]';
      if (typeof v === 'bigint') return v.toString();
      return v;
    }),
  ) as Prisma.InputJsonValue;
}

/** Append-only audit trail (CLAUDE.md rule 5). Pass the transaction client to stay atomic. */
export async function audit(db: Db, actor: AuditActor, entry: AuditEntry): Promise<void> {
  await db.auditLog.create({
    data: {
      companyId: actor.companyId,
      userId: actor.userId ?? null,
      ip: actor.ip ?? null,
      action: entry.action,
      entity: entry.entity,
      entityId: entry.entityId == null ? null : String(entry.entityId),
      before: scrub(entry.before),
      after: scrub(entry.after),
    },
  });
}
